import Filters from "./Filters";
import Monitoring from "./Monitoring";
import VideoPlayer from "./VideoPlayer";

export default {
    Filters,
    Monitoring,
    VideoPlayer
}